export default `:host {
  height: inherit;
  display: block;
}

:host([hidden]) {
  display: none;
}

.ids-empty-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: inherit;
}
.ids-empty-message .button {
  margin-block-start: var(--ids-empty-message-button-margin-block-start);
}
.ids-empty-message .icon {
  fill: var(--ids-empty-message-color-icon-fill);
  color: var(--ids-empty-message-icon-color);
  margin: var(--ids-empty-message-icon-margin);
  height: var(--ids-empty-message-icon-height);
  width: var(--ids-empty-message-icon-width);
}
.ids-empty-message .label {
  padding: var(--ids-empty-message-label-padding);
  color: var(--ids-empty-message-label-color-text);
}
.ids-empty-message .label ::slotted(span) {
  font-size: var(--ids-empty-message-label-font-size);
}
.ids-empty-message .description {
  padding: var(--ids-empty-message-description-padding);
  text-align: var(--ids-empty-message-description-font-align);
  color: var(--ids-empty-message-description-color-text);
}
@media all and (max-width: 767px) {
  .ids-empty-message {
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
  }
}
@media all and (max-width: 320px) {
  .ids-empty-message {
    max-width: 220px;
  }
  .ids-empty-message .label {
    text-align: center;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
